module.exports = __webpack_public_path__ + "06d3765b9aaee917c250afc4448be755.pdf";